<template>
  <g>
    <g clip-path="url(#clip0_15_265)">
      <path
        d="M7 24.0002H9V22.0002H7V24.0002ZM11 24.0002H13V22.0002H11V24.0002ZM15 24.0002H17V22.0002H15V24.0002ZM16 0.0101831L8 0.000183105C6.9 0.000183105 6 0.900183 6 2.00018V18.0002C6 19.1002 6.9 20.0002 8 20.0002H16C17.1 20.0002 18 19.1002 18 18.0002V2.00018C18 0.900183 17.1 0.0101831 16 0.0101831ZM16 16.0002H8V4.00018H16V16.0002Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_265">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000183105)"
        />
      </clipPath>
    </defs>
  </g>
</template>
